import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=25ba972f&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=25ba972f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba972f",
  null
  
)

export default component.exports